import React from "react";
import FacingText from "../components/FacingText";
import GuillotinePanel from "../panels/GuillotinePanel";
import { useTranslation } from "react-i18next";
import "../i18n";

const Guillotine3D = ({ isExporting, config, isOpenTrigger, aluminumColor, glassColor, glassColor2 }) => {
  const sideThickness = 0.18;
  let posX = 0, posZ = 0, angleSum = 0;
  const group = [];
  const { t } = useTranslation();
  
  config?.sections?.map((section, index) => {
    const { width, height } = section.size || {};
    const w = width / 1000;
    const h = height / 1000;
    const angleRad = (angleSum * Math.PI) / 180;
    const dirX = Math.cos(angleRad);
    const dirZ = Math.sin(angleRad);
    const rotation = [0, -angleSum * (Math.PI / 180), 0];

    const leftBox = section.left_box;
    const rightBox = section.right_box;
    const panelWidth = w + (leftBox ? sideThickness : 0) + (rightBox ? sideThickness : 0) - 0.08;
    const panelOffsetX = posX + dirX * (panelWidth / 2);
    const panelOffsetZ = posZ + dirZ * (panelWidth / 2);

    group.push(
      <GuillotinePanel
        panelId={`panel-${index}`}
        section={section}
        width={w}
        height={h}
        index={index}
        position={[panelOffsetX, h/2, panelOffsetZ]}
        isOpenTrigger={isOpenTrigger}
        config={config}
        rotation={rotation}
        almColor={aluminumColor}
        glassColor={glassColor}
        glassColor2={glassColor2}
        isExporting={isExporting}
      />
    );
    posX += dirX * (panelWidth+0.08);
    posZ += dirZ * panelWidth;
    angleSum += parseFloat(section.angle || 0);
  });

  return (
    <>
      {group}
    </>
  );
};

export default Guillotine3D;
